export enum EntityDataAttribute {
	Booking = 'booking',
	WaitListItem = 'wait-list-item',
}
